import { render } from "./ProdutosTabPage.vue?vue&type=template&id=d62a5dc8"
import script from "./ProdutosTabPage.vue?vue&type=script&lang=js"
export * from "./ProdutosTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__